import { render, staticRenderFns } from "./vehicle-item.vue?vue&type=template&id=7d5d8c3a&scoped=true"
import script from "./vehicle-item.vue?vue&type=script&lang=js"
export * from "./vehicle-item.vue?vue&type=script&lang=js"
import style0 from "./vehicle-item.vue?vue&type=style&index=0&id=7d5d8c3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5d8c3a",
  null
  
)

export default component.exports